import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Avatar } from '@fiverr-private/fit';
import { Container, Stack } from '@fiverr-private/layout_components';
import { FederatedSeller, useSellerData, useIsSellerOnline } from '@fiverr-private/seller_pages_toolbox';
import { Fade } from '@fiverr-private/transition';
import { useIsXl } from '../../../hooks/useMediaQuery';
import { BaseInfo } from './BaseInfo';
import { avatarWrClass, avatarWrWithImageClass } from './styles.ve.css';

interface HeadingProps {
    withAvatar?: boolean;
}

// There is an issue with Avatar component. We don't know what size of avatar to render during SSR.
// This hook is a workaround to render big one during SSR and then re-render correct one on client side.
const useAvatarSize = () => {
    const [useBreakPoints, setUseBreakPoints] = useState(false);
    useEffect(() => setUseBreakPoints(true), []);

    const isLG = useIsXl();
    const breakpointSize = isLG ? 48 : 32;
    return useBreakPoints ? breakpointSize : 48;
};

export const Heading: React.FC<HeadingProps> = ({ withAvatar = false }) => {
    const { username, profileImageUrl } = useSellerData(selectSellerSlice);
    const isOnline = useIsSellerOnline();
    const avatarSize = useAvatarSize();

    return (
        <Stack gap="0">
            <Container
                flexShrink="0"
                className={classNames(avatarWrClass, {
                    [avatarWrWithImageClass]: withAvatar,
                })}
            >
                <Fade in={withAvatar} duration="moderate1">
                    <div>
                        <Avatar
                            size={avatarSize}
                            username={username}
                            src={profileImageUrl}
                            isOnline={isOnline}
                            showOnlineIndicator={isOnline}
                            onlineIndicatorSize={8}
                            onlineIndicatorPosition={(Avatar as any).ONLINE_INDICATOR_POSITIONS.BOTTOM_RIGHT}
                        />
                    </div>
                </Fade>
            </Container>
            <Stack justifyContent="spaceBetween" flexGrow="1">
                <BaseInfo withAvatar={withAvatar} />
            </Stack>
        </Stack>
    );
};

const selectSellerSlice = (seller: FederatedSeller) => ({
    sellerId: seller.user.id,
    isPro: seller.isPro,
    username: seller.user.name,
    displayName: seller.user.profile.displayName,
    profileImageUrl: seller.user.profileImageUrl,
});
